import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'
import { fillString } from '@local_modules/generic/string-template.js'

import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'

import htmlTemplateIndex from './index.html'
import { context, updateView } from './update-view.js'
import { showSelectors } from './show-selectors.js'

import { activateActions } from './activate-actions.js'

/**
 *
 * @returns
 */
export async function showPageMonthlyAnalysisPG (params) {
  console.log('showPageMonthlyAnalysisPG')
  const { containerElementId, browserAppUser, browserAppAccount, analysisType } = params

  if (!checkPageRestriction({ browserAppUser, browserAppAccount, allowPublic: true })) return

  const analysisTypeLabel = analysisTypes[analysisType]

  // Prepare the html
  let htmlIndex = htmlTemplateIndex
  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, {
    elementId,
    pageTitle: analysisTypeLabel
  })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  document.title = [analysisTypeLabel, ': ', browserAppAccount.data.appAccount.name].join(' ')

  // Set full height
  document.getElementById(containerElementId).classList.add('position-absolute')
  document.getElementById(containerElementId).classList.add('top-to-bottom')

  context.analysisType = analysisType
  context.browserAppAccount = browserAppAccount

  showSelectors(updateView, browserAppAccount)

  activateActions(document.getElementById(elementId))
}

const analysisTypes = {
  topExpenses: 'Biggest Expenses',
  newExpenses: 'New Expenses',
  endedExpenses: 'Ended Expenses',
  topRevenue: 'Top Revenue Contributors',
  newRevenue: 'New Revenue Contributions',
  endedRevenue: 'Lost Revenue Contributors',
  allPnl: 'All P&L impacts'
}
